import React from 'react'
import { Collapsible, CollapsibleProps } from './Collapsible'

interface CollapsibleListProps {
	items: Array<Omit<CollapsibleProps, 'large'>>
	large?: CollapsibleProps['large']
}

export const CollapsibleList: React.FunctionComponent<CollapsibleListProps> = (
	props,
) => {
	const { items, large } = props
	const [keyPrefix, setKeyPrefix] = React.useState(1)

	// Collapse all categories when list of items changes
	React.useEffect(() => {
		setKeyPrefix(keyPrefix + 1)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [items])

	return (
		<div className="collapsibleList">
			<div className="collapsibleList-in">
				{items.map((item, i) => (
					<Collapsible key={`${keyPrefix}-${i}`} large={large} {...item} />
				))}
			</div>
		</div>
	)
}
